import { ExitVariant, LeadMagnetState } from '@/types/lead-magnet';

export const selectExitVariant = (
	state: LeadMagnetState,
	totalQuestions: number
): ExitVariant | null => {
	if (state.stage === 'intro') return 'intro';

	// The breakdown is the end of the road: leaving is fine, so the modal offers a
	// rerun instead of talking the user back into an unfinished quiz.
	if (state.stage === 'breakdown') return 'result';

	if (state.stage !== 'question') return null;

	return state.currentIndex === totalQuestions - 1 ? 'lastQuestion' : 'inProgress';
};
